module.exports = __webpack_public_path__ + "static/media/1-1.2d908ff4.webp";